module.exports = __webpack_public_path__ + "img/hualu-jianj.ebd326fe.png";